angular.module('picmonicng').component('homeAchievements', {
  templateUrl: '/templates/app/components/home-achievements/home-achievements.html',
  bindings: {
    visible: '<',
    onToggle: '&',
  },
  controller: [
    'UserService',
    'User',
    function (UserService, User) {
      var ctrl = this;
      ctrl.UserService = UserService;
      timezone = moment.tz.guess();
      if (!UserService.user.settings.timezone) {
        UserService.user.settings.timezone = timezone;
      }

      ctrl.achievements = User.queryv3({ resource: 'achievements' });

      // XP
      User.queryv3(
        {
          resource: 'xp',
        },
        function (result) {
          ctrl.xp = result[6].xp;
        }
      );
    },
  ],
});
